export const userSearchType = [
  "Username",
  "Name",
  "Nickname",
  "Email",
  "Player Name",
];
